import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/csms',
    component: Layout
  },
  {
    path: '/csms',
    component: Layout,
    name: 'CSMS',
    redirect: '/csms/secret',
    meta: { title: 'CSMS' },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard.vue'),
        meta: { title: 'Dashboard' }
      },
      {
        path: 'application',
        name: 'Application',
        component: () => import(/* webpackChunkName: "application" */ '../views/application.vue'),
        meta: { title: 'Application' }
      },
      {
        path: 'secret',
        name: 'Secret',
        component: () => import(/* webpackChunkName: "secret" */ '../views/secret.vue'),
        meta: { title: 'Secret' }
      },
      {
        path: 'policy',
        name: 'Policy',
        component: () => import(/* webpackChunkName: "application" */ '../views/policy.vue'),
        meta: { title: 'Policy' }
      },
      {
        path: 'instance',
        name: 'Instance',
        component: () => import(/* webpackChunkName: "application" */ '../views/instance.vue'),
        meta: { title: 'Instance' }
      },
      {
        path: 'extend',
        name: 'Extend',
        component: () => import(/* webpackChunkName: "extend" */ '../views/extendrole.vue'),
        meta: { title: 'Extend' }
      },
      {
        path: 'developer',
        name: 'Developer',
        component: () => import(/* webpackChunkName: "developer" */ '../views/developer.vue'),
        meta: { title: 'Developer' }
      },
      {
        path: 'statistics',
        name: 'Hash',
        component: () => import(/* webpackChunkName: "hash" */ '../views/hash.vue'),
        meta: { title: 'Hash' }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/401',
    name: '401',
    component: () => import('../views/401.vue')
  },
  {
    path: '/403',
    name: '403',
    component: () => import('../views/403.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
